window.colorMap = {
  "abete": "#0d3d32",
  "acqua": "#8da4a7",
  "antracite": "#293133",
  "arancio": "#ffa500",
  "arancio fluo": "#ff5f00",
  "argilla": "#8b462e",
  "avorio": "#c0af91",
  "avion": "#7498bb",
  "azzurro": "#a2c7e4",
  "basement": "#808080",
  "beige": "#f5f5dc",
  "beigemelange": "#787980",
  "bigpoint fuxia": "#ff00ff",
  "bianco": "#ffffff",
  "blueberry": "#7d072b",
  "black": "#000000",
  "black/black": "#000000",
  "blu": "#2f2e49",
  "blu scuro": "#2f2e49",
  "boat": "#4682b4",
  "bordeaux": "#5e171d",
  "bronzo-fuxia fluo": "#b76e79",
  "brown": "#4c2e28",
  "burro":"#f4dbbb",
  "cacao": "#624332",
  "camou": "#78866b",
  "cammello": "#a68565",
  "celeste": "#b2ffff",
  "chocolate": "#462827",
  "ciclamino-tabacco": "#8b5a2b",
  "cielo": "#87ceeb",
  "cioccolato": "#624332",
  "cobalto": "#1e213d",
  "cobalto-arancio fluo": "#0047ab",
  "coccio": "#6c2224",
  "coffe": "#624332",
  "coffee": "#624332",
  "coccio-giallo fluo": "#ffd700",
  "coccio-rosso fluo": "#ff4500",
  "copiativo": "#312d53",
  "corals": "#ff7f50",
  "corda": "#d5b296",
  "crema": "#f3e4d4",
  "dark blu": "#2f2e49",
  "dark brown": "#442d25",
  "dark grey": "#333638",
  "dark sand" : "#eae4d7",
  "denim": "#052c49",
  "forest": "#013b31",
  "fossil": "#a68473",
  "fucsia": "#cb0241",
  "fuxia": "#cb0241",
  "fuxia fluo":"#fe347c",
  "geometric": "#808080",
  "geranio": "#c6bab1",
  "giada": "#6e899d",
  "giallo": "#fce903",
  "glicine": "#d8bfd8",
  "gold print": "#ffd700",
  "green": "#0e6e6c",
  "grey": "#403d39",
  "grey melange": "#9c9d99",
  "grigio": "#989392",
  "grigioantracite": "#898689",
  "grigiochiaro": "#dbdbdb",
  "grigio melange": "#213842",
  "grigiomedio": "#6b666c",
  "grigioscuro": "#393232",
  "ice": "#f0f8ff",
  "lavender": "#e6e6fa",
  "lavagna": "#373737",
  "leaf": "#228b22",
  "liberty green": "#00ff7f",
  "light blue": "#add8e6",
  "light fuxia": "#f7cddb",
  "light green": "#66b29d",
  "light grey": "#d6dadf",
  "light mint": "#a5d6d4",
  "light peach": "#ffdab9",
  "light yellow": "#f5dc8a",
  "lilac": "#c8a2c8",
  "lilla": "#c8a2c8",
  "lime": "#caca6e",
  "line": "#808080",
  "line green": "#008000",
  "mandorla": "#69473c",
  "majolica": "#007ba7",
  "margherita white": "#ffffff",
  "marrone": "#964b00",
  "medusa": "#800080",
  "milk": "#fffdd0",
  "military": "#4b5320",
  "mini flower lilla": "#c8a2c8",
  "minipalm green": "#00ff00",
  "minipalm lime": "#00ff00",
  "minipalm royal": "#4169e1",
  "mint": "#98ff98",
  "mint-white": "#f5fffa",
  "moro": "#6b5e5a",
  "mou": "#e1913f",
  "nautical blu": "#014088",
  "nautical blue": "#014088",
  "navy": "#282f4d",
  "nero": "#000000",
  "nude-black": "#8b4513",
  "octopus": "#800000",
  "off white": "#faf0e6",
  "olive": "#808000",
  "onion": "#a77173",
  "orange": "#ffa500",
  "orchidea": "#944f8e",
  "oro": "#fffacd",
  "ottanio": "#008b8b",
  "ottanio-mandarino": "#ffa500",
  "palms": "#228b22",
  "panna": "#cec7b5",
  "peach": "#ffdab9",
  "peach-corallo fluo": "#ff7f50",
  "perla": "#ddd6d4",
  "petrol": "#074160",
  "petrolio": "#074160",
  "pietra": "#bc9f8c",
  "pink": "#ffaab6",
  "polvere": "#b9c6c0",
  "postcard": "#4682b4",
  "purple": "#806567",
  "red": "#ff0000",
  "rosa": "#ffaab6",
  "rosa fluo": "#f77876",
  "rosa porpora-water grey": "#8a2be2",
  "rosaantico": "#d6b8a6",
  "rosso": "#cc0000",
  "salvia": "#9cb3b6",
  "sand": "#d5c3ac",
  "sabbia": "#a69592",
  "scart red": "#b22222",
  "senape": "#f1c616",
  "sky": "#9acde3",
  "smeraldo": "#1d6066",
  "smog": "#373737",
  "solar": "#e3ce98",
  "starfish": "#f4a460",
  "sunny": "#ffd700",
  "tabacco": "#8b5a2b",
  "tortora": "#a69592",
  "turcheese": "#0798c5",
  "turquoise": "#0798c5",
  "verde": "#49b675",
  "verdelaguna": "#02947e",
  "verdone": "#716f5b",
  "vinaccio": "#7d5050",
  "water": "#9adecb",
  "wateranimal": "#20b2aa",
  "white": "#ffffff",
  "white/orange": "#fffaf0",
  "yellow": "#ffff00",
  "yellow/dark blue": "#cccc00",
  "yellow/navy": "#fee715",
  "zucchero": "#859fb1"
};
